<template>
  <div>
    <a-form
      :form="form"
      layout="inline"
      class="mgb_10"
    >
      <a-form-item label="文章ID">
        <a-input v-decorator="['id']" :style="{ width: '120px' }" />
      </a-form-item>
      <a-form-item label="文章模块">
        <a-select
          :style="{ width: '300px' }"
          v-decorator="['type', { initialValue: 0 }]"
        >
          <a-select-option :value="0">
            全部
          </a-select-option>
           <a-select-option :value="typeMap.THE_LATEST_FROM_BIGO.value">
            {{ typeMap.THE_LATEST_FROM_BIGO.msg }}
          </a-select-option>
          <a-select-option :value="typeMap.BIGO_ON_THE_MEDIA.value">
            {{ typeMap.BIGO_ON_THE_MEDIA.msg }}
          </a-select-option>
          <a-select-option :value="typeMap.CREATOR_STORIES.value">
            {{ typeMap.CREATOR_STORIES.msg }}
          </a-select-option>
        </a-select>
      </a-form-item>
    
      <a-form-item label="文章标题">
        <a-input v-decorator="['title']" />
      </a-form-item>
      <a-form-item label="优先级">
        <a-input-number v-decorator="['priority']" />
      </a-form-item>
      <a-form-item label="是否首页推荐">
        <a-select
          :style="{ width: '100px' }"
          v-decorator="[
            'isRecommend',
            { initialValue: '2' }
          ]"
        >
          <a-select-option value="2">全部</a-select-option>
          <a-select-option value="1">是</a-select-option>
          <a-select-option value="0">否</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="添加日期">
        <a-range-picker v-decorator="['timeRange']" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" class="mgr_10" @click="handleFilter">查询</a-button>

        <router-link to="/article/edit">
          <a-button>新建文章</a-button>
        </router-link>
      </a-form-item>
    </a-form>

   <a-table
    rowKey="id"
    :columns="columns"
    :dataSource="articles"
    :pagination="pagination"
    @change="handleTableChange"
  >
    <template slot="cover" slot-scope="cover">
      <img :src="cover" alt="" class="cover" />
    </template>

    <template slot="actions" slot-scope="_, record">
      <router-link :to="`/article/${record.id}/edit`">
        <a-button
          type="primary"
          class="mgr_10"
        >编辑</a-button>
      </router-link>
      <a-button type="danger" @click="promptConfirm(record.id)">删除</a-button>
    </template>
   </a-table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
import { tinyObject } from '@/utils/common';
import { articleTypeMap } from '@/constant/article';

const pageSize = 20;
const columns = [
  {
    title: '文章ID',
    dataIndex: 'id',
    sorter: true,
  },
  {
    title: '文章模块',
    dataIndex: 'type',
    customRender: type => {
      const keys = Object.keys(articleTypeMap);
      for (let index = 0; index < keys.length; index++) {
        const key = keys[index];
        if (articleTypeMap[key].value === type) {
          return articleTypeMap[key].msg;
        }
      }
    },
  },
  {
    title: '标题',
    dataIndex: 'title',
  },
  {
    title: '封面图',
    dataIndex: 'cover',
    scopedSlots: { customRender: 'cover' },
  },
  {
    title: '优先级',
    dataIndex: 'priority',
    sorter: true,
  },
  {
    title: '是否首页推荐',
    dataIndex: 'isRecommend',
    customRender: isRecommend => (isRecommend ? '是' : '否'),
  },
  {
    title: '添加日期',
    dataIndex: 'createdAt',
    sorter: true,
    customRender: time => moment(time).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    title: '操作',
    dataIndex: 'actions',
    scopedSlots: { customRender: 'actions' },
  },
];

let filterOptions = {};
let sorterOption = {};

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      columns,
      // 文章模块的映射
      typeMap: articleTypeMap,
    };
  },
  computed: {
    ...mapState(['articles']),
    pagination() {
      return this.$store.state.articlePage;
    },
  },
  created() {
    this.handleFetch({ limit: 20, offset: 0 });
  },
  beforeDestroy() {
    filterOptions = {};
    sorterOption = {};
  },
  methods: {
    ...mapActions([
      'getArticles',
      'delArticle',
    ]),
    promptConfirm(id) {
      this.$confirm({
        onOk: () => this.delArticle(id),
        title: '确认删除？',
        okText: '确认',
        cancelText: '取消',
      });
    },
    handleTableChange(page, filter, sorter) {
      const { current } = page;
      // eslint-disable-next-line prefer-const
      let { field, order } = sorter;

      if (field === 'createdAt') {
        field = 'created_at';
      }

      sorterOption = field
        ? { field, order: order.replace('end', '') }
        : {};

      this.handleFetch({
        offset: (current - 1) * pageSize,
        ...filterOptions,
        sorter: sorterOption,
      });
    },
    handleFetch(query) {
      const params = {
        limit: pageSize,
        offset: 0,
        ...query,
      };

      this.getArticles(params);
    },
    handleFilter() {
      this.form.validateFields((err, fieldValues) => {
        const options = tinyObject(fieldValues, val => Boolean(val));

        if (fieldValues.timeRange && fieldValues.timeRange.length) {
          options.startAt = `${fieldValues.timeRange[0].format('YYYY-MM-DD')} 00:00:00`;
          options.endAt = `${fieldValues.timeRange[1].format('YYYY-MM-DD')} 23:59:59`;
          delete options.timeRange;
        }

        if (options.isRecommend && options.isRecommend > 1) {
          delete options.isRecommend;
        }

        filterOptions = options;
        this.handleFetch(options);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cover {
  width: 150px;
}
</style>
